// extracted by mini-css-extract-plugin
export default {"list":"Approach_list__4BipE","item":"Approach_item__iQKU1","index":"Approach_index__X9Z8r","text":"Approach_text__1AVf5"};